import { atom } from "jotai";
import { Pageable } from "../../../services/pageable";
import { UsersDTO } from "../../../store/users/models/dto";

export const merchantPagination = atom<
  Pageable.T<keyof UsersDTO.Responses.GetSingle.T> & {
    options?: { excludeSubMerchants?: boolean };
  }
>({
  pagination: {
    size: 20,
    page: 0,
  },
  sorting: {
    direction: "desc",
    field: "createdDate",
  },
  options: {
    excludeSubMerchants: false,
  },
});
